import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import * as typeformEmbed from '@typeform/embed';
import env from '../../env';
import usePageTitle from '../../Common/Hooks/usePageTitle';
import MinimalHeader from '../Components/MinimalHeader';

const Container = styled.div`
  width: 100%;
  padding: 60px 120px;
`;

const StyledTypeform = styled.div`
  height: 135vh;
  width: 100%;
`;

const ExtensionUninstalled: React.FC = () => {
  usePageTitle('Extension Uninstalled');

  const typeformRef = useRef<HTMLDivElement>(document.createElement('div'));

  useEffect(() => {
    typeformEmbed.makeWidget(
      typeformRef.current,
      `https://form.typeform.com/to/${env.extension_uninstall_typeform_id}?typeform-welcome=0`,
      {
        hideFooter: true,
        hideHeaders: true,
        hideScrollbars: true,
        onSubmit: () => {
          if (typeformRef) {
            typeformRef.current.style.height = '50vh';
            typeformRef.current.style.width = '100%';
            typeformRef.current.style.paddingLeft = '0';
          }
        },
        onReady: () => {
          if (typeformRef) {
            typeformRef.current.style.paddingLeft = '8%';
            typeformRef.current.style.marginTop = '0';
          }
        },
      }
    );
  }, [typeformRef]);

  return (
    <Container>
      <MinimalHeader uninstallHeading />
      <StyledTypeform ref={typeformRef} id="uninstall-survey" />
    </Container>
  );
};

export default ExtensionUninstalled;
